<template>
    <div class="icon-single container">
        <router-link to="/"><i class="eq-icon eq-icon-home"></i> All Icons</router-link>
        <transition name="slide-fade" appear>
            <div class="notification" v-if="copying">
                <p>Copied Character</p>
                <span @click="copying = !copying">&times;</span>
            </div>
        </transition>
        <article v-if="data.icon">
            <header>
                <div class="icon-wrapper">
                    <i
                        v-for="index in 3"
                        :key="index"
                        @click="copyText($event, 'character')"
                        class="eq-icon"
                        :id="'icon-' + index"
                        :class="data.icon"
                        title="Click to copy"
                    ></i>
                </div>
                <div>{{ data.icon }}</div>
            </header>
            <IconInputGroup label="Character" :value="data.character" />
            <IconInputGroup label="Class Name" :value="data.icon" />
            <IconInputGroup label="HTML Snippet" :value="data.htmlSnippet" />
        </article>
    </div>
</template>

<script>
import { reactive } from 'vue';
import IconInputGroup from './IconInputGroup';
export default {
    name: 'Icon',
    components: {
        IconInputGroup,
    },
    data() {
        return {
            copying: false,
        };
    },
    setup() {
        const data = reactive({
            icon: null,
            htmlSnippet: '',
            character: null,
        });
        return {
            data,
        };
    },
    mounted() {
        this.data.icon = this.$route.params.id;
        this.data.htmlSnippet = `<i class="eq-icon ${this.data.icon}"></i>`;
    },
    methods: {
        selectText(start, end, event) {
            event.target.setSelectionRange(start, end);
        },
        async copyText(event, input) {
            try {
                await navigator.clipboard.writeText(this.data[input]);
                this.copying = !this.copying;
            } catch (error) {
                console.error(error);
            }
        },
    },
    updated() {
        let str = getComputedStyle(document.querySelector(`.${this.data.icon}`), ':before').getPropertyValue('content');

        function getCharacter() {
            // for some reason, it seems that Safari treats the variable as a string and not an array, this fixes that
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (isSafari) {
                return str;
            } else {
                return str[1];
            }
        }
        this.data.character = getCharacter();
        document.title = 'EQ Icon: ' + this.data.icon;
    },
};
</script>

<style lang="scss" scoped>
.icon-single {
    margin-top: 2rem;

    a {
        color: inherit;
    }
}
article {
    font-size: 2.3rem;
    margin: 3rem;
    color: inherit;
    text-decoration: none;
}
header {
    display: flex;
    div {
        align-items: center;
        display: flex;
        width: 100%;
    }
    .icon-wrapper {
        width: max-content;
        margin-right: 0.5rem;
        i.eq-icon {
            border-radius: 2px;
            cursor: pointer;
            font-size: 4.5rem;
            padding: 0.5rem;
            justify-content: center;
        }
        i.eq-icon:nth-child(2) {
            font-size: 3rem;
        }
        i.eq-icon:nth-child(3) {
            font-size: 2rem;
        }
    }
}
.notification {
    border-top: 5px solid #7ed3fd;
    border-radius: 2px;
    position: absolute;
    background: white;
    padding: 1rem 2rem;
    box-shadow: 0 0 35px rgba(0, 0, 0, 0.2);
    width: 50vw;
    top: calc(33vh - 4rem);
    z-index: 999999;
    left: 25vw;
    span {
        cursor: pointer;
        position: absolute;
        right: 0.25rem;
        top: 4px;
        font-size: 2rem;
        padding: 1rem 2rem;
    }
}
.slide-fade-enter-active {
    transition: all 0.35s ease-in-out;
}
.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(-500px);
    opacity: 0;
}
</style>
